export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9365.92c04f7c.jpg";